import { render, staticRenderFns } from "./MaterialsTable.vue?vue&type=template&id=aa2533c2&scoped=true"
import script from "./MaterialsTable.vue?vue&type=script&lang=js"
export * from "./MaterialsTable.vue?vue&type=script&lang=js"
import style0 from "./MaterialsTable.vue?vue&type=style&index=0&id=aa2533c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa2533c2",
  null
  
)

export default component.exports